module.exports = __webpack_public_path__ + "static/media/design3.6b407c12.jpg";